import TileMatch from './playgrounds/TileMatch';
import SupervisorScored from './playgrounds/SupervisorScored';
import SequenceTap from './playgrounds/SequenceTap';
import TimerHold from './playgrounds/TimerHold';
import { PLAYERS } from '../games/kinds';
import type { ConceptDef } from './types';

export default function LibraryPlayground({ concept }: { concept: ConceptDef }) {
  switch (concept.kind) {
    case 'tileMatch':
      return <TileMatch config={concept.config} />;
    case 'supervisorScored':
      return <SupervisorScored config={concept.config} />;
    case 'sequenceTap':
      return <SequenceTap config={concept.config} />;
    case 'timerHold':
      return <TimerHold config={concept.config} />;
    default: {
      const Player = PLAYERS[concept.kind];
      return <Player key={concept.id} config={concept.config} />;
    }
  }
}
